import React from 'react';
import Providers from '../../components/PublicSite/Providers';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';
import loadSiteCopy from '../../components/PublicSite/loadSiteCopy';

async function action() {
  await loadSiteCopy();
  return {
    title: 'Drive With Us — Recovery Truck Partners | Bas Recovery',
    description: 'Own a recovery truck in the UAE? Receive jobs near you, set your own hours, 18% commission and weekly payouts. Apply in 10 minutes.',
    component: (
      <HeadLessLayout>
        <Providers />
      </HeadLessLayout>
    ),
  };
}

export default action;
